<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M4 4a2 2 0 0 0-2 2v4a2 2 0 1 1 0 4v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 1 0-4V6a2 2 0 0 0-2-2zm11.5 3L17 8.5 8.5 17 7 15.5zM8.8 7a1.8 1.8 0 1 1 0 3.6 1.8 1.8 0 1 1 0-3.6m6.4 6.4a1.8 1.8 0 1 1 0 3.6 1.8 1.8 0 1 1 0-3.6"
    />
  </svg>
</template>
